import React from "react";
import { IClient } from "../../../common/interfaces/IClient";
import ClientSettingsBox from "../Clients/ClientSettingsBox/ClientSettingsBox";

interface IProductChildNotEligibleProps {
    className?: string;
    allowChildren: boolean;
    clients: IClient[];
}

const ProductChildNotEligible: React.FC<IProductChildNotEligibleProps> = (props) => {
    const { className, allowChildren, clients } = props;

    if (allowChildren) {
        return null;
    }

    const childClients = clients.filter((c) => c.isChild);

    if (childClients.length === 0) {
        return null;
    }

    return (
        <ClientSettingsBox
            key={`client-child`}
            className={!!className ? className : ""}
            title="Children"
            subtitle={`${childClients.length} ${
                childClients.length > 1 ? "children" : "child"
            }`}>
            <span className="text-font-size-s">
                Children aren&apos;t eligible for this product on their own policy;
                however, some insurers may have options available as an added benefit.
                Please contact us for further information.
            </span>
        </ClientSettingsBox>
    );
};

export default ProductChildNotEligible;
